//DEVICES
export const GET_DEVICES = 'GET_DEVICES';
export const ERROR_DEVICES = 'ERROR_DEVICES';
export const GET_DEVICES_MASTER_LIST = 'GET_DEVICES_MASTER_LIST';
export const ERROR_DEVICES_MASTER_LIST = 'ERROR_DEVICES_MASTER_LIS';
export const GET_OFFSET_LOADING='GET_OFFSET_LOADING';
export const GET_EXCEL_DATA = 'GET_EXCEL_DATA';
export const ERROR_GET_EXCEL_DATA = 'ERROR_GET_EXCEL_DATA';
//CLEAR DEVICES
export const CLEAR_DEVICES = 'CLEAR_DEVICES'